import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Loader from "../../Components/Loader";
import { LoginReducer } from "../../features/slice";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [countryData, setCountryData] = useState();
  const [countryName, setCountryName] = useState("India");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <section className="bg-image">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="my-4">
                <img
                  src="assets/images/logo.png"
                  className="img-fluid logo-admin"
                  alt="logo"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <div className="row UserLoginImg">
            <div className="col-sm-12 col-md-12 col-lg-6 position-relative">
              <img
                src="assets/images/Loginimg.png"
                alt=""
                className="lft-img"
              />
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6">
              <div className="form-bg">
                <Formik
                  initialValues={{
                    mobile: "",
                    countryCode: "91",
                  }}
                  validationSchema={Yup.object({
                    mobile: Yup.string().required("Required"),
                  })}
                  onSubmit={(values, action) => {
                    setLoading(true);
                    dispatch(
                      LoginReducer({
                        countryCode: values.countryCode,
                        phoneNumber: values.mobile,
                        deviceType: "W",
                      })
                    ).then(async (data) => {
                      setLoading(false);
                      if (data?.payload?.code === 3) {
                        toast.success(data?.payload?.message);
                        await localStorage.setItem(
                          "houzezToken",
                          data?.payload?.data?.authToken
                        );
                        await localStorage.setItem(
                          "countryCode",
                          data?.payload?.data?.countryCode
                        );
                        await localStorage.setItem(
                          "mobile",
                          data?.payload?.data?.phoneNumber
                        );
                        navigate("/otp-verification", {
                          replace: true,
                        });
                      } else {
                        setLoading(false);
                        toast.error(data?.payload?.message);
                      }
                    });
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFormikState,
                    setFieldValue,
                  }) => (
                    <form
                      className="form-style mt-5"
                      onSubmit={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleSubmit();
                      }}
                    >
                      <div className="row">
                        <div className="col-sm-12 col-md-12 mb-2 mt-5">
                          <h2 className="mdl-ttl">Login</h2>
                          <p>
                            Lorem ipsum dolor sit amet, consectetueradipiscing
                            elit. Aenean commodo ligula eget dolor. Aenean massa
                          </p>
                        </div>
                        <div className="col-sm-12 col-md-12 mb-4">
                          <div className="form-group">
                            <div className="input-container mobileInput">
                              <PhoneInput
                                country="in"
                                inputProps={{
                                  name: "mobile",
                                }}
                                enableSearch
                                value={values.countryCode + values.mobile}
                                onChange={(
                                  phone,
                                  country,
                                  e,
                                  formattedValue
                                ) => {
                                  setCountryName(country.name);
                                  setCountryData({ formattedValue, country });
                                  if (phone.length > 0) {
                                    const raw = phone.slice(
                                      country?.dialCode?.length
                                    );
                                    setFieldValue("mobile", raw);

                                    setFieldValue(
                                      "countryCode",
                                      formattedValue?.split(" ")[0]
                                    );
                                  } else {
                                    setFieldValue("mobile", "");

                                    setFieldValue("countryCode", "");
                                  }
                                }}
                                onBlur={handleBlur}
                                placeholder="Enter Phone Number"
                                containerclassName="form-control signupClass"
                                inputclassName="phoneInputClass"
                              />
                              <span className="countryName">{countryName}</span>
                              <img
                                src="assets/images/phone.png"
                                className="input-img"
                                alt=""
                              />
                            </div>
                          </div>
                          {errors.mobile && touched.mobile && (
                            <div className="text-red"> {errors.mobile}</div>
                          )}
                        </div>
                        {/* <div className="col-sm-12 col-md-12 text-end mb-4">
                        <Link to="/forgot-password">
                          <span className="forgot-pass cursor-pointer fw-bold">
                            Forgot Password?
                          </span>
                        </Link>
                      </div> */}
                        <div className="col-sm-12 col-md-12 text-center mb-5">
                          <button type="submit" className="btn btn-save w-100">
                            {loading ? <Loader /> : "Continue"}{" "}
                            {loading ? null : (
                              <img src="assets/images/Arrowbtn.png" alt="" />
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Login;
